import { toRefs as m, computed as e, openBlock as c, createElementBlock as p, normalizeClass as d, toDisplayString as g } from "vue";
import f from "./design-system.es116.js";
/* empty css                    */
import b from "./design-system.es128.js";
const _ = {
  name: "DsPaginationShowing",
  props: {
    /**
     * The total number of items
     */
    total: {
      type: Number,
      required: !0
    },
    /**
     * The start index of the items
     */
    start: {
      type: Number,
      required: !0
    },
    /**
     * The end index of the items
     */
    end: {
      type: Number,
      required: !0
    },
    /**
     * Whether to use the subtle variant
     */
    subtle: Boolean
  },
  setup(n) {
    const r = f(), t = new Intl.NumberFormat("en-US"), {
      total: o,
      start: a,
      end: s
    } = m(n), i = e(() => t.format(a.value)), u = e(() => t.format(s.value)), l = e(() => t.format(o.value));
    return {
      showingLabel: e(() => r.t("pagination.showing", {
        start: i.value,
        end: u.value,
        total: l.value
      }))
    };
  }
};
function h(n, r, t, o, a, s) {
  return c(), p("span", {
    class: d(["ds-pagination-showing", { "ds-pagination-showing--subtle": t.subtle }])
  }, g(o.showingLabel), 3);
}
const S = /* @__PURE__ */ b(_, [["render", h], ["__scopeId", "data-v-06c1b0d8"]]);
export {
  S as default
};
//# sourceMappingURL=design-system.es306.js.map
